// extracted by mini-css-extract-plugin
export default {"customFields":"Order-Detail_customFields__08ojV","box":"Order-Detail_box__6nSEs","line":"Order-Detail_line__mUj6q","field":"Order-Detail_field__pgwIT"};